import WaitingListService from '../../../services/WaitingListService'
import React, { Fragment, useState } from 'react'
import AuthenticatedComponent from '../../AuthenticatedComponent'
import WaitingListEntryComponent from './WaitingListEntryComponent'

function WaitingListComponent(props) {
  const [showInfo, setShowInfo] = useState(false);
  const [paid, setPaid] = useState(props.waitingListEntry.paid);
  const [approved, setApproved] = useState(props.waitingListEntry.approved);

  const toggleShowInfo = () => {
    setShowInfo(!showInfo);
  };

  const checkBoxClick = () => {
    if (props.isWaitingList) {
      WaitingListService.updateWaitinglistEntryPayment({
        id: props.waitingListEntry.id,
        paid: !props.waitingListEntry.paid,
      }).catch((err) => {
        setPaid(props.waitingListEntry.paid);
      });
    } else {
      if (
        window.confirm(
          `er du sikker på at du vil godkende ${props.waitingListEntry.person.firstname}s ansøgning`,
        )
      ) {
        WaitingListService.updateApplicationApproval({
          id: props.waitingListEntry.id,
          approved: !props.waitingListEntry.approved,
        }).catch((err) => {
          setApproved(props.waitingListEntry.approved);
        });
      }
    }
  };

  return (
    <React.Fragment>
      <tr className="according-toggle clickMobile">
        <td style={{ textAlign: 'center' }} onClick={toggleShowInfo}>
          {props.count} -{' '}
          <span style={{ fontSize: '0.9em' }}>
            {props.waitingListEntry.listtype &&
              props.waitingListEntry.listtype.letter}
          </span>
        </td>
        {props.isWaitingList && props.waitingListEntry.initiated && (
          <td>
            <input
              type="checkbox"
              onClick={checkBoxClick}
              checked={paid}
              onChange={(event) =>
                setPaid(event.target.checked)
              }
            />
          </td>
        )}
        {props.isWaitingList && !props.waitingListEntry.initiated && (
          <td>
            <input type="checkbox" checked={true} disabled />
          </td>
        )}
        {!props.isWaitingList && (
          <Fragment>
            <td>
              <div className="btn btn-success" onClick={checkBoxClick}>Godkend</div>
            </td>
            <td style={{ textAlign: 'center' }}>
              <span
                className={
                  paid ? 'bi bi-check-circle' : 'bi bi-circle-fill'
                }
              >
                &nbsp;
              </span>
            </td>
          </Fragment>
        )}
        <td onClick={toggleShowInfo}>
          {props.waitingListEntry.person &&
            props.waitingListEntry.person.firstname}{' '}
          {props.waitingListEntry.person &&
            props.waitingListEntry.person.lastname}
        </td>
        <td onClick={toggleShowInfo}>
          {props.waitingListEntry.person &&
            props.waitingListEntry.person.address}{' '}
          {props.waitingListEntry.person &&
            props.waitingListEntry.person.postcode}{' '}
          {props.waitingListEntry.person &&
            props.waitingListEntry.person.suburb}
        </td>
        <td>
          {props.waitingListEntry.person != null ? (
            <a
              href={
                'mailto:' +
                (props.waitingListEntry.person.email != null
                  ? props.waitingListEntry.person.email
                  : 'no@email.com') +
                '?Subject=Kontakt'
              }
              target="_top"
            >
              {props.waitingListEntry.person &&
                props.waitingListEntry.person.email}
            </a>
          ) : (
            ''
          )}
        </td>

        <td onClick={toggleShowInfo}>
          {props.waitingListEntry.person &&
            props.waitingListEntry.person.phone}
        </td>
      </tr>
      {showInfo ? (
        <WaitingListEntryComponent
          isWaitingList={props.isWaitingList}
          waitingListEntry={props.waitingListEntry}
          toggleShowInfo={toggleShowInfo}
        ></WaitingListEntryComponent>
      ) : null}
    </React.Fragment>
  );
}
export default AuthenticatedComponent(WaitingListComponent)
